import React from 'react';
import RoleMaintenanceCard from '../components/RoleMaintenanceCard';

export default function RoleMaintenanceScreen() {
  return <RoleMaintenanceCard />;
}
